import { useIsFocused } from "expo-router/react-navigation";
import { router } from 'expo-router';
import { useLayoutEffect } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import { useUpdateNonProfitOrg } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import NpoFundraisingForm from '@/components/forms/NpoFundraisingForm';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { FundRaisingData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const Fundraising = () => {
  const { state: authState } = useAuth();
  const { state: npoScreensState, setCurrentPage } = useNpoLoginScreenState();
  const { mutateAsync: onBoardingUpdate, isPending: onBoardingIsPending } = useNpoOnboarding(
    authState.signUpData?.loginEmail?.type ?? 'CHURCH'
  );
  const { mutateAsync: nonProfitUpdate, isPending: nonProfitIsPending } = useUpdateNonProfitOrg();

  const isFocused = useIsFocused();
  useLayoutEffect(() => {
    if (isFocused) setCurrentPage(12);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoScreensState.initialNpoData ?? '');

  const onSubmit: SubmitHandler<FundRaisingData> = async (data) => {
    try {
      nonProfitUpdate(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          totalFundraisingMarketing: data.totalFundraisingMarketing
        },
        {
          onSuccess: () => {
            onBoardingUpdate(
              {
                preferenceId: authState.preferenceId ?? '',
                fundraising: true
              },
              {
                onSuccess: () => {
                  if (authState.signUpData?.loginEmail?.type === 'CHURCH') {
                    router.navigate('/(app)/login/nonProfit/onBoarding/programs');
                  } else {
                    router.navigate('/(app)/login/nonProfit/onBoarding/totalGrantsPrograms');
                  }
                }
              }
            );
          },
          onError: (e) => {
            console.error(e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoFundraisingForm
      nonProfitOrg={nonProfitOrg}
      isLoading={onBoardingIsPending || nonProfitIsPending}
      onSubmitTapped={onSubmit}
    />
  );
};

export default Fundraising;
